// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"b5-z","dimensionLabel":"c5-z","styleChooserControlWrapper":"d5-z","styleChooserControl":"e5-z","disabled":"f5-z","giftCard":"g5-z","styleChooserText":"h5-z"};